<div class="flow-preview--wrapper">
  <div class="flow-preview--content" *ngIf="flowInfo">
    <div class="preview-image-title">
      <img
        class="image"
        [src]="flowInfo?.tiles?.[0]?.image || flowInfo?.croppedImage"
        alt="preview"
      />
    </div>
  </div>
</div>
